import { defineComponent as _defineComponent } from 'vue'
import {useScheduleStore} from '@/components/calculator/services/ScheduleStore';
import {ScheduleRow} from '@/components/calculator/schedule/Schedule';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowMoreRow',
  props: {
    item: null,
    print: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  item: ScheduleRow;
  print: boolean;
}



const store = useScheduleStore();

return { __sfc: true,props, store }
}

})